import { useState } from "react";
import { Location } from "@components/ui/location_input.tsx";
import { router } from "@inertiajs/react";
import { SearchBar } from "@components/job_search/search_bar.tsx";

const SearchSection = () => {
  const [location, setLocation] = useState<Location | null>(null);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    setLoading(true);

    router.get(
      "/jobs",
      {
        query: query || undefined,
        location: location?.display_name,
        lat: location?.latitude,
        lon: location?.longitude,
      },
      {
        onFinish: () => setLoading(false),
      },
    );
  };

  return (
    <div className="welcome-search-bar-wrapper">
      {
        <SearchBar
          query={query}
          onQueryChange={setQuery}
          location={location}
          onLocationChange={setLocation}
          onSearch={handleSearch}
          disabled={loading}
        />
      }
    </div>
  );
};

export default SearchSection;
